var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('rcp-data-table',{attrs:{"items":_vm.rcps,"loading":_vm.loading},on:{"recharge":function($event){return _vm.getRcps()},"switchProcessamentosExpirados":function($event){_vm.processamentosExpirados = $event,
      _vm.getRcps()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }